import AbstractModel from '@model-core/core/AbstractModel';
import type { SaveOptions } from '@model-core/core/AbstractConnector';
import apiConnector from '@/models/connectors/apiConnector';

export default abstract class AbstractApiModel extends AbstractModel {
  protected _connector = apiConnector;

  _tsFilters: Record<string, unknown> = {};
  _tsSorts: Record<string, unknown> = {};

  /** Ressource dont l'URI désigne déjà l'objet (ex. /users/me) : save() fait un PATCH même sans id */
  protected _isSingleton = false;

  /**
   * Comme model-core, avec un PATCH en application/merge-patch+json : API Platform refuse un PATCH en ld+json (415).
   * Corrigé ici plutôt que dans model-core (sous-module partagé).
   */
  async save(attributes = this.attributes, saveOptions?: SaveOptions) {
    if (!this.id && !this._isSingleton) return super.save(attributes, saveOptions);

    const response = await this.connector.save(
      this.fullPath,
      attributes,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/merge-patch+json' },
        silentError: saveOptions?.silentError,
      },
      saveOptions,
    );
    this.setAttributes(response.data as ModelAttributes);

    return { model: this, response };
  }

  /**
   * DELETE de collection (StoneCode DeleteCollection) : supprime d'un coup les objets filtrés, une suppression par objet
   * contrôlée comme un DELETE simple, dans une transaction (tout ou rien). Rend le nombre d'objets supprimés.
   */
  async destroyWhere(filters: Partial<this['_tsFilters']>): Promise<number> {
    const query = new URLSearchParams(Object.entries(filters).map(([key, value]) => [key, String(value)]));
    const response = await this.connector.destroy(`${this.fullPath}?${query}`);

    return (response.data as { deleted: number }).deleted;
  }
}
